export const formatDateForOutput = ({
  date,
  withTime,
  withYear,
}: {
  date: Date;
  withTime: boolean;
  withYear: boolean;
}) => {
  const options = {
    year: withYear ? "numeric" : undefined,
    month: "numeric",
    day: "numeric",
    hour: withTime ? "numeric" : undefined,
    minute: withTime ? "numeric" : undefined,
  } satisfies Intl.DateTimeFormatOptions;

  const returnValue = date.toLocaleString(undefined, options);

  return returnValue;
};
